import { Box, Breadcrumbs, Paper, Typography } from '@mui/material';
import { styled } from '@mui/system';
import LaptopChromebookIcon from '@mui/icons-material/LaptopChromebook';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import WorkIcon from '@mui/icons-material/Work';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Container = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    gap: 2,
});

const Title = styled(Typography)(({ theme }) => ({
    fontSize: '1.2rem',
    fontWeight: '600',
}));

const MenuSelectionContainer = styled(Box)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "24px",
});

const MenuSelectionItem = styled(Paper)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    gap: '8px',
    padding: "12px",
    minWidth: '200px',
    maxWidth: '500px',
    width: "100%",
    textAlign: "center",
    cursor: "pointer",
    fontWeight: "500",
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: theme.shadows[1],
    "&:hover": {
        border: `2px solid ${theme.palette.primary.main}`,
        boxShadow: theme.shadows[3],
    },
}));
const MenuSelectionText = styled(Typography)(({ theme }) => ({

}));

const AdminMenuView = () => {
    const currentUser = useSelector((state) => state.user.currentUser);
    const navigate = useNavigate();

    console.log(currentUser);

    const handleConfigSelection = (section) => {
        navigate(`/admin/${section}`);
    };

    return (
        <Container>
            <Breadcrumbs aria-label="breadcrumb">
                <Typography color="text.primary">Home</Typography>
            </Breadcrumbs>

            <Title component='h1'>Virtual CTRL</Title>

            <MenuSelectionContainer>
                {currentUser.roles.includes('Manager') &&
                    <MenuSelectionItem onClick={() => handleConfigSelection('gestao')}>
                        <WorkIcon />
                        <MenuSelectionText component='p'>Gestão</MenuSelectionText>
                    </MenuSelectionItem>
                }
                {currentUser.roles.includes('Technician') &&
                    <MenuSelectionItem onClick={() => handleConfigSelection('tecnico')}>
                        <LaptopChromebookIcon />
                        <MenuSelectionText component='p'>Técnico</MenuSelectionText>
                    </MenuSelectionItem>
                }
                {currentUser.roles.includes('Attendant') &&
                    <MenuSelectionItem onClick={() => handleConfigSelection('atendimento')}>
                        <SupportAgentIcon />
                        <MenuSelectionText component='p'>Atendimento</MenuSelectionText>
                    </MenuSelectionItem>
                }
            </MenuSelectionContainer>
        </Container>
    )
}
export default AdminMenuView;